import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedCreador from './components/ProtectedCreador';
import ProtectedAdmin from './components/ProtectedAdmin';


import Home from './pages/Home';
import PerfilPage from './pages/Perfil';
import PerfilContenido from './pages/PerfilContenido';
import Admin from './pages/Panel_admin';
import LoginAdmin from './pages/Login_admin';
import AccesoPublicar from './pages/accesoPublicarRegistrarse';
import AccesoViewer from './pages/acceso_viewer';
import RegistroViewer from './pages/Registro_viewer';
import RegistroContenido from './pages/Registro_contenido';
import SesionViewer from './pages/sesion_viewer';
import VideoPrincipal from './pages/Video_principal';
import PanelCreador from './pages/Panel_creador';
import PublicaAnuncio from './pages/Publica_anuncio';
import EditarPublicacion from './pages/Editar_publicacion';
import EstadoPublicaciones from './pages/Estado_publicaciones';
import EstadoEdicion from './pages/Estado_edicion';
import ProcesoVerificacion from './pages/Proceso_verificacion';
import EstadoVerificacion from './pages/Estado_verificacion';
import SaldoOrdenCompra from './pages/Saldo_ordencompra';
import AgregarSaldo from './pages/Agregar_saldo';
import GestionAvisos from './pages/Gestion_avisos';              
import PublicacionPausa from './pages/publicacion_pausa';      
import PublicacionRenovar from './pages/publicacion_renovar';
import CambioContrasenaCreador from './pages/cambio_contrasena_creador';
import TextosLegales from './pages/Textos_legales';
import RestablecerClave from './pages/Restablecer_clave';
import VerificarEmail from './pages/Verificar_email';
import RestablecerClaveViewer from './pages/Restablecer_clave_viewer';
import VerificarEmailViewer from './pages/Verificar_email_viewer';

import HMUNDO from './pages/HolaMundo';
import HookDemo from './pages/HookDemo';

function App() {
  return (
    <div className="App">
      {/* Contenedor para las particulas flotantes - ESTE ES EL ELEMENTO QUE NECESITAS */}
      <div id="animatedBg" className="animated-background"></div>
      
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/holamundo" element={<HMUNDO />} />
            <Route path="/hookdemo" element={<HookDemo />} />
            <Route path="/" element={<Home />} />
            <Route path="/panel_admin_login" element={<LoginAdmin />} />
            <Route element={<ProtectedAdmin />}>
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="/perfil" element={<PerfilPage />} />
            <Route path="/PerfilContenido" element={<PerfilContenido />} />
            <Route path="/acceso-publicar" element={<AccesoPublicar />} />
            <Route path="/acceso_viewer" element={<AccesoViewer />} />
            <Route path="/registro_viewer" element={<RegistroViewer />} />
            <Route path="/registro_contenido" element={<RegistroContenido />} />
            <Route path="/sesion_viewer" element={<SesionViewer />} />
            <Route path="/Video_principal" element={<VideoPrincipal />} />
<Route element={<ProtectedCreador />}>
              <Route path="/panel_creador" element={<PanelCreador />} />
              <Route path="/publica_anuncio" element={<PublicaAnuncio />} />
              <Route path="/editar_publicacion" element={<EditarPublicacion />} />
              <Route path="/estado_publicaciones" element={<EstadoPublicaciones />} />
              <Route path="/estado_edicion" element={<EstadoEdicion />} />
              <Route path="/proceso_verificacion" element={<ProcesoVerificacion />} />
              <Route path="/estado_verificacion" element={<EstadoVerificacion />} />
              <Route path="/saldo_ordencompra" element={<SaldoOrdenCompra />} />
              <Route path="/agregar_saldo" element={<AgregarSaldo />} />
              <Route path="/gestion_avisos" element={<GestionAvisos />} />
              <Route path="/publicacion_pausa" element={<PublicacionPausa />} />
              <Route path="/publicacion_renovar" element={<PublicacionRenovar />} />
              <Route path="/cambio_contrasena_creador" element={<CambioContrasenaCreador />} />
            </Route>
            <Route path="/textos-legales" element={<TextosLegales />} />
            <Route path="/restablecer_clave" element={<RestablecerClave />} />
            <Route path="/verificar_email" element={<VerificarEmail />} />
            <Route path="/restablecer_clave_viewer" element={<RestablecerClaveViewer />} />
            <Route path="/verificar_email_viewer" element={<VerificarEmailViewer />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;